const NAMESPACE = "upgradeTemplateConfirmationDialog";

const KEYS = {
    testEnvironmentAlert: "testEnvironmentAlert",
    upgradeTitle: "upgradeTitle",
    analyzeAllTitle: "analyzeAllTitle",
    upgradeAllTitle: "upgradeAllTitle",
    communicationType: "communicationType",
    documentType: "documentType",
    analyzeMessage: "analyzeMessage",
    upgradeMessage: "upgradeMessage"
};

const MESSAGES = {
    [KEYS.testEnvironmentAlert]: {
        value: "There is an open Test Environment for this program. If you continue with this upgrade, you will have to repeat the same upgrade in the Test Environment before committing it.",
        comment: "Info to user about what to do when a Test Environment is open"
    },
    [KEYS.upgradeTitle]: {
        value: "Upgrade Template",
        comment: "Title for message with only one template to upgrade"
    },
    [KEYS.analyzeAllTitle]: {
        value: "Analyze All Templates",
        comment: "Title for message to analyze all templates"
    },
    [KEYS.upgradeAllTitle]: {
        value: "Upgrade All Templates",
        comment: "Title for message to upgrade all templates"
    },
    [KEYS.communicationType]: {
        value: "Communication Templates",
        comment: "The type name of templates used in Communications"
    },
    [KEYS.documentType]: {
        value: "Document Templates",
        comment: "The type name of templates used in Documents"
    },
    [KEYS.analyzeMessage]: {
        value: "This will analyze all {templateType} in this program to determine whether they can be automatically upgraded to Smart Templates. This will not modify any template. Do you want to proceed?",
        comment:
            "Message to user about what will happen when they try to analyze the templates along with the template type"
    },
    [KEYS.upgradeMessage]: {
        value: "This will attempt to upgrade all {templateType} in this program to Smart Templates. This will not result in any behavioral changes where the templates are used. Action may be required to upgrade certain templates. This process may take several minutes, and you will not be able to make changes to individual templates during that time. Do you want to proceed?",
        comment:
            "Message to user about what will happen when they try to upgrade the templates along with the template type"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
